module.exports = __webpack_public_path__ + "static/media/1017078.fe7e0306.png";